/* ============
 * Purchase Receive Transformer
 * ============
 */

import Transformer from './transformer';
import productTrans from './purchaseProduct';

export default class PurchaseReceiveTransformer extends Transformer {

  static fetch(receive) {
    return {
      quantity: receive.quantity,
      qtyReceived: receive.quatity_received,
      shortage: receive.shortage,
      notes: receive.notes,
    };
  }

  static send(receive) {
    return {
      receive_date: receive.receiveDate,
      products: productTrans.sendCollection(receive.products),
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/purchaseReceive.js